<ion-content>
  <ion-row class="align-items-center ion-justify-content-center">
    <h1>Page not Found</h1>
  </ion-row>
</ion-content>
